<nz-page-header nzTitle="Analytics Dashboards"></nz-page-header>
<nz-table *ngIf="dashboards" nzSize="default" 
	[nzData]="dashboards" 
	[nzFrontPagination]="false"
	[nzBordered]="true"
	[nzLoading]="loading"
	[nzTotal]="total"
	[nzPageSize]="pageSize"
	[nzPageIndex]="pageIndex"
	[nzShowSizeChanger]="true"
	[nzPageSizeOptions]="[5, 10, 15, 20, 25, 50, 100]"
	(nzQueryParams)="onQueryParamsChange($event, getThis())">
	<thead>
		<tr>
			<th>ID</th>
			<th>Synced At</th>
			<th>Dashboard ID</th>
			<th>Title</th>
			<th>Tag</th>
			<th>Viewed</th>
			<th>Status</th>
			<th>View</th>
			<th>Set as Homepage</th>
		</tr>
	</thead>
	<tbody>
		<tr *ngFor="let item of dashboards">
			<td>{{item.id}}</td>
			<td>{{item.syncedAt | date:'yyyy-MM-dd HH:mm'}}</td>
			<td>{{item.dashboardId}}</td>
			<td>{{item.dashboardTitle}}</td>
			<td><nz-tag>{{item.dashboardClientTag}}</nz-tag></td>
			<td>{{item.viewed}}</td>
			<td>{{item.status}}</td>
			<td nzAlign="center">
                <button nz-button nzType="dashed" nzSize="small" (click)="openViewModal(item)">
					<fa-icon [icon]="faEye" class="me-2"></fa-icon>
					<span >View</span>
                    <!-- <span nz-icon nzType="eye"></span> View -->
                </button>
            </td>
			<td nzAlign="center">
				<span nz-icon 
					[nzType]="'star'" 
					[nzTheme]="item.favourite ? 'fill' : 'outline'"
					[style.color]="'#fadb14'"
					style="font-size: 20px; cursor: pointer;"
					(click)="toggleFavourite(item)">
				</span>
			</td>
			<!-- <td><button nz-button nzType="default" (click)="setFavourite(item)">Set Favourite</button></td> -->
		</tr>
	</tbody>
</nz-table>

<nz-modal
    [(nzVisible)]="isModalVisible"
    [nzTitle]="selectedDashboard?.dashboardTitle || 'Dashboard View'"
    [nzFooter]="null"
    nzWidth="90%"
    (nzOnCancel)="handleModalCancel()">
    
    <ng-container *nzModalContent>
        <div #modalDashboardContainer style="width: 100%; height: 80vh; display: flex; align-items: center; justify-content: center;">
            <nz-spin nzSimple [nzSize]="'large'"></nz-spin>
        </div>
    </ng-container>
</nz-modal>